document.addEventListener("DOMContentLoaded", function () {
	const hasBeltTag = document.querySelector("variant-radios[data-belt-tag]");
	if (!hasBeltTag) return;

	// Get the current product handle from URL
	const currentPath = window.location.pathname;
	const productMatch = currentPath.match(/\/products\/([^\/\?]+)/);
	if (!productMatch || !productMatch[1]) {
		// console.log("No product match found in URL");
		return;
	}

	const currentProductHandle = productMatch[1];
	const productFamily = currentProductHandle.split("-in-")[0];
	// console.log("Current product:", currentProductHandle);
	// console.log("Product family:", productFamily);

	const lastVisitedProduct = sessionStorage.getItem("lastVisitedProduct");
	if (lastVisitedProduct && lastVisitedProduct !== currentProductHandle) {
		// Check if it's a different product family
		const lastProductFamily = lastVisitedProduct.split("-in-")[0];

		if (lastProductFamily !== productFamily) {
			console.log(
				"Navigated to a different product family. Clearing variant selection data."
			);
			// Clear all variant selection related data
			sessionStorage.removeItem("clickedVariantPosition");
			sessionStorage.removeItem("clickedVariantHandle");
			sessionStorage.removeItem("currentBeltFamily");
			sessionStorage.removeItem("currentVariantIndex");
			sessionStorage.removeItem("previousVariantIndex");

			const sizeKeys = [];
			// Collect all size-related keys to remove
			for (let i = 0; i < sessionStorage.length; i++) {
				const key = sessionStorage.key(i);
				if (key && key.endsWith("_selectedSize")) {
					sizeKeys.push(key);
				}
			}
			// Remove all size keys
			sizeKeys.forEach(key => {
				sessionStorage.removeItem(key);
			});
			console.log("Cleared all size selection data");
		}
	}

	// Always update the lastVisitedProduct
	sessionStorage.setItem("lastVisitedProduct", currentProductHandle);

	const allVariantSwatches = document.querySelectorAll(".variant-swatch");
	// console.log("All variant swatches found:", allVariantSwatches.length);
	if (allVariantSwatches.length < 1) {
		// console.log("Not enough variants found");
		return; // Not enough variants, exit early
	}

	// Read the stored data
	const clickedPosition = sessionStorage.getItem("clickedVariantPosition");
	const clickedHandle = sessionStorage.getItem("clickedVariantHandle");
	const prevProductFamily = sessionStorage.getItem("currentBeltFamily");

	console.log("Stored data:", {
		clickedPosition,
		clickedHandle,
		prevProductFamily,
		currentProductFamily: productFamily,
	});

	// hide selected size label border to help with the transition
	let selectedSizeLabel = document.querySelector(
		".product-form__input input[type=radio]:checked+label.size-style"
	);
	if (selectedSizeLabel) {
		const originalBorder = window.getComputedStyle(selectedSizeLabel).border;
		selectedSizeLabel.dataset.originalBorder = originalBorder;
		selectedSizeLabel.style.borderColor = "transparent";
	}

	// Set up the variant swatches for ordering
	const variantContainers = document.querySelectorAll(".variant-labels");
	if (variantContainers.length === 0) {
		// console.log("Variant container not found");
		return;
	}
	// console.log("Setting up variant container for ordering");
	variantContainers.forEach(container => {
		container.style.display = "flex";
		container.style.flexWrap = "wrap";
        container.style.alignItems = "baseline";
		container.style.gap = ".4rem";
		container.classList.remove("tw-opacity-0");
	});

	// Get the default swatch (label) and any static variant links
	const defaultSwatch = document.querySelector("label.color-swatch");
	const staticVariantLinks = document.querySelectorAll("a.variant-swatch");

	if (!defaultSwatch) {
		// console.log("Default swatch not found");
		return;
	}

	// Get the current variant index
	const currentVariantIndex =
		parseInt(defaultSwatch.getAttribute("data-variant-index")) ||
		parseInt(
			document
				.querySelector("fieldset")
				.getAttribute("data-current-variant-index")
		) ||
		1;

	// console.log("Current variant index:", currentVariantIndex);

	// Add variant-wrapper--color class to default swatch if needed
	if (!defaultSwatch.classList.contains("variant-wrapper--color")) {
		defaultSwatch.classList.add("variant-wrapper--color");
	}

	// Actually need to move the input before assigning order
	const inputRadio = document.querySelector('input[name="Material"]:checked');
	if (inputRadio) {
		// Position the input and label together by creating a wrapper
		const wrapper = document.createElement("div");
		wrapper.className = "default-variant-wrapper";
		wrapper.style.order = currentVariantIndex;

		// Get references to elements
		const parent = inputRadio.parentNode;
		const nextElement = inputRadio.nextElementSibling;

		// Move the elements to our wrapper
		parent.insertBefore(wrapper, inputRadio);
		wrapper.appendChild(inputRadio);
		wrapper.appendChild(nextElement);

		console.log("Radio and label wrapped and ordered:", currentVariantIndex);
	}

	// Set orders for all static variants
	staticVariantLinks.forEach(link => {
		const position = link.getAttribute("data-variant-position");
		if (position) {
			console.log("Setting order for static variant:", position);
			link.style.order = position;
		}
	});

	setTimeout(() => {
		console.log("Fading in all variant containers");
		variantContainers.forEach(container => {
			container.classList.remove("tw-opacity-0");
			container.classList.add("tw-opacity-100");
		});

		// After fade-in is complete, restore the border
		setTimeout(() => {
			selectedSizeLabel.style.removeProperty("border-color");
		}, 600); // Slightly longer than the fade-in transition
	}, 200);

	// Only process further if we have clicked a variant AND we're in the correct product family
	if (
		clickedPosition &&
		clickedHandle &&
		prevProductFamily === productFamily
	) {
		// console.log("Processing variant ordering from previous click");

		// Clear session storage after use
		// console.log("Clearing session storage");
		sessionStorage.removeItem("clickedVariantPosition");
		sessionStorage.removeItem("clickedVariantHandle");
	} else {
		// console.log(
		// 	"No reordering needed from previous click - either no click data or different product family"
		// );
		// Clear session storage if we're in a different product family
		if (prevProductFamily && prevProductFamily !== productFamily) {
			// console.log("Different product family - clearing session storage");
			sessionStorage.removeItem("clickedVariantPosition");
			sessionStorage.removeItem("clickedVariantHandle");
			sessionStorage.removeItem("currentBeltFamily");
		}
	}

	// Add click handlers to static variants
	staticVariantLinks.forEach(link => {
		link.addEventListener("click", function () {
			const position = this.getAttribute("data-variant-position");
			const handle = this.getAttribute("data-variant-handle");

			// console.log("Clicked variant:", position, handle);

			// Store the current product family and clicked variant info
			sessionStorage.setItem("currentBeltFamily", productFamily);
			sessionStorage.setItem("clickedVariantPosition", position);
			sessionStorage.setItem("clickedVariantHandle", handle);
		});
	});

	// ---- SIZE VARIANT PERSISTENCE ----
	// Re-using currentPath,productMatch,productFamily,currentProductHandle

	let productVariants = [];
	const variantsScript = document.getElementById("product-variants-json");
	if (variantsScript) {
		try {
			productVariants = JSON.parse(variantsScript.textContent);
			console.log("Found product variants:", productVariants.length);
		} catch (e) {
			console.error("Error parsing product variants:", e);
		}
	}

	// Check for size variant in URL
	const urlParams = new URLSearchParams(window.location.search);
	const variantId = urlParams.get("variant");

	// Get all size inputs
	const sizeInputs = document.querySelectorAll('input[name="Size"]');

	if (sizeInputs.length > 0) {
		// If we have a variant ID in the URL, extract size from variants data
		if (variantId && productVariants.length > 0) {
			// Find the current variant in our variant data
			const currentVariant = productVariants.find(
				v => v.id.toString() === variantId
			);
			if (currentVariant && currentVariant.option2) {
				// Assuming Size is option2, adjust if needed
				const selectedSize = currentVariant.option2;
				console.log(
					"Saving selected size from variant data:",
					selectedSize
				);
				sessionStorage.setItem(
					`${productFamily}_selectedSize`,
					selectedSize
				);
			}
		}

		// Check if we have a saved size for this product family
		const savedSize = sessionStorage.getItem(`${productFamily}_selectedSize`);
		if (savedSize) {
			console.log(
				"Found saved size:",
				savedSize,
				"for product family:",
				productFamily
			);

			// Find the input with this size value
			const sizeInput = document.querySelector(
				`input[name="Size"][value="${savedSize}"]`
			);
			if (sizeInput) {
				// Check if this size exists and is not disabled
				if (!sizeInput.disabled) {
					sizeInput.checked = true;
					sizeInput.dispatchEvent(new Event("change", { bubbles: true }));
					console.log("Size selected:", savedSize);

					// If we have the variant data, we can also update the URL with the correct variant ID
					if (productVariants.length > 0) {
						// Get the current color/material selection
						const colorInput = document.querySelector(
							'input[name="Material"]:checked, input[name="Color"]:checked'
						);
						if (colorInput) {
							const colorValue = colorInput.value;

							// Find the variant that matches both color and size
							const matchingVariant = productVariants.find(
								v =>
									(v.option1 === colorValue &&
										v.option2 === savedSize) ||
									(v.option1 === savedSize && v.option2 === colorValue)
							);

							if (matchingVariant) {
								// Update URL with the correct variant ID without reloading the page
								const newUrl = new URL(window.location.href);
								newUrl.searchParams.set("variant", matchingVariant.id);
								window.history.replaceState({}, "", newUrl.toString());
								console.log(
									"Updated URL with matching variant ID:",
									matchingVariant.id
								);
							}
						}
					}
				} else {
					console.log("Size is unavailable:", savedSize);
				}
			} else {
				console.log("Size does not exist for this product:", savedSize);
			}
		}

		// Add event listeners to size inputs to save the selection
		sizeInputs.forEach(input => {
			input.addEventListener("change", function () {
				if (this.checked) {
					sessionStorage.setItem(
						`${productFamily}_selectedSize`,
						this.value
					);
					console.log("Size selected and saved:", this.value);
				}
			});
		});

		// Also handle clicks on the size labels
		const sizeLabels = document.querySelectorAll("label.size-style");
		sizeLabels.forEach(label => {
			label.addEventListener("click", function () {
				// Find the associated input
				const inputId = this.getAttribute("for");
				const input = document.getElementById(inputId);
				if (input) {
					sessionStorage.setItem(
						`${productFamily}_selectedSize`,
						input.value
					);
					console.log("Size selected via label click:", input.value);
				}
			});
		});
	}
});
